import React from 'react';
type Variante = 'azul' | 'verde' | 'verdeOutline';
interface CtaButtonProps {
  href: string;
  variante: Variante;
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  compacto?: boolean;
  /** Halo pulsante + destello, para los CTA persistentes de la barra fija. */
  atencion?: boolean;
}
const estilos: Record<Variante, string> = {
  azul: 'bg-[#2AABE2] text-white hover:bg-[#1d97cc] hover:shadow-[0_0_24px_rgba(42,171,226,0.65)] focus-visible:outline-[#2AABE2]',
  verde: 'bg-[#25D366] text-[#08301a] hover:bg-[#1fbb59] hover:shadow-[0_0_24px_rgba(37,211,102,0.6)] focus-visible:outline-[#25D366]',
  verdeOutline: 'border-2 border-[#1a9c4b] text-[#12763a] hover:bg-[#25D366] hover:text-[#08301a] hover:border-[#25D366] hover:shadow-[0_0_24px_rgba(37,211,102,0.5)] focus-visible:outline-[#1a9c4b]'
};
const halos: Record<Variante, string> = {
  azul: 'rgba(42, 171, 226, 0.55)',
  verde: 'rgba(37, 211, 102, 0.55)',
  verdeOutline: 'rgba(37, 211, 102, 0.45)'
};
export function CtaButton({
  href,
  variante,
  children,
  icon,
  className = '',
  compacto = false,
  atencion = false
}: CtaButtonProps) {
  const externo = href.startsWith('http');
  return <a href={href} {...externo ? {
    target: '_blank',
    rel: 'noreferrer noopener'
  } : {}} style={atencion ? {
    '--cta-glow': halos[variante]
  } as React.CSSProperties : undefined} className={`relative isolate inline-flex items-center justify-center gap-2 overflow-hidden whitespace-nowrap rounded-full font-semibold tracking-[0.12em] transition-[background-color,border-color,color,transform,box-shadow] duration-300 ease-out hover:scale-[1.05] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 motion-reduce:transition-none motion-reduce:hover:scale-100 ${compacto ? 'px-5 py-2.5 text-xs' : 'px-7 py-3.5 text-sm'} ${estilos[variante]} ${atencion ? 'cta-attention' : ''} ${className}`} data-id="element-38" data-mp="3exkufdpstxmv">
      {icon}
      {children}
      {atencion && <span aria-hidden="true" className="cta-shine pointer-events-none absolute inset-y-0 -z-10 w-1/3 bg-gradient-to-r from-transparent via-white/45 to-transparent" data-id="element-39" data-mp="3myih1dbwgw9d" />}
    </a>;
}